namespace SP {
    export interface PickLineInfo {
        id: string;
        orderId: number;
        shipmentId: string;
        orderLineId: string;
        quantity: number;
        pickedQuantity: number;
        orderNo: string;
        toteId: number;
        toteName: string;
        toteColor: string;
        extraText: string;
        allowLocationScanPicking: number;
    }
}